var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-popover',_vm._g({ref:"popover",staticClass:"popover",attrs:{"trigger":_vm.trigger,"placement":_vm.position,"delay":_vm.delay,"handle-resize":""}},_vm.listeners),[_c('div',{staticClass:"popover-trigger"},[_vm._t("default")],2),_c('div',{staticClass:"popover-content",attrs:{"slot":"popover"},slot:"popover"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }